<template>
  <v-main>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col align-self="center" sm="8" md="6" lg="4" xl="4">
          <v-card outlined class="elevation-2 mx-auto pa-4">
            <div class="d-flex justify-center align-center">
              <img :src="logo" alt="Gigalogy Logo" class="logo" />
            </div>
            <v-card-title class="font-weight-bold mb-1">
                パスワードをお忘れですか？
            </v-card-title>
            <v-card-subtitle>
              メールアドレスを入力してください。パスワードをリセットするためのリンクが送信されます。
            </v-card-subtitle>
            <v-card-text>
              <v-form ref="emailForm" @submit.prevent="handleSubmitClick">
                <v-text-field
                  label="メールアドレス"
                  type="email"
                  v-model="emailForm.email"
                  placeholder="adam@gigalogy.com"
                  prepend-inner-icon="email"
                  outlined
                  :rules="[
                    required('メールアドレス'),
                    email('メールアドレス'),
                  ]"
                ></v-text-field>
                <v-btn
                  color="primary"
                  large
                  block
                  type="submit"
                  :loading="loading"
                  class="mt-2"
                  >
                  送信
                  </v-btn
                >
              </v-form>
              <v-divider class="my-5"></v-divider>
              <router-link to="/login" class="text-decoration-none">
                ログインに戻る
              </router-link>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from "vuex";
import getEnv from "@/config/env";
import { SEND_PASSWORD_RESET_LINK, ADD_ALERT } from "@/store/_actiontypes";
import validations from "@/helpers/validations";

export default {
  name: "ForgotPasswordPage",
  data() {
    return {
      logo: require("@/assets/images/logo_horizontal.png"),
      emailForm: {
        email: "",
      },
      loading: false,
      ...validations,
    };
  },
  methods: {
    ...mapActions("account", [SEND_PASSWORD_RESET_LINK]),
    ...mapActions("alert", [ADD_ALERT]),
    async handleSubmitClick() {
      if (!this.$refs?.emailForm?.validate()) return;
      this.loading = true;

      const clientIP = await this.$ipCheck?.getClientIP();
      const isAllowed = await this.$ipCheck?.ipRangeCheck(clientIP);

      const executeReset = async (recaptcha_token = null) => {
        this.SEND_PASSWORD_RESET_LINK({
          email: this.emailForm.email,
          reset_page_route: "reset-password/",
          recaptcha_token,
          clientIP: clientIP,
        })
          .then((response) => {
            if (response?.data?.message) {
              this.ADD_ALERT({
                message: response.data.message,
                color: "success",
              });
            }
          })
          .catch((err) => {
            console.error("Password reset error:", err);
            if (err?.response?.data?.message) {
              this.ADD_ALERT({
                message: err.response.data.message,
                color: "error",
              });
            } else {
              this.ADD_ALERT({
                message: "パスワードリセットに失敗しました",
                color: "error",
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      };

      if (getEnv("VUE_APP_CAPTCHA_ENABLED") && !isAllowed) {
        this.$recaptcha
          .execute("reset_password")
          .then((recaptcha_token) => {
            return executeReset(recaptcha_token);
          })
          .catch((error) => {
            console.error("reCaptcha error:", error);
            this.loading = false;
          });
      } else {
        await executeReset();
      }
    },
  },
};
</script>

<style scoped>
.logo {
  max-height: 55px;
  vertical-align: middle;
}
</style>
